import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import {
  ArrowLeftIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useContext, useEffect, useState } from "react";
import { PrimaryMobile } from "../../../buttons/mobile/Primary";
import { RewardStory } from "./RewardStory";
import * as url from "../../../../helpers/url_helper";
import { APIClient } from "../../../../helpers/api_helper";
import img_empty_rewards from '../../../../public/svg/empty_rewards.svg';
import { RewardsViewContext } from "../../../../context/Disclosures/rewards/rewardsContext";

const api = new APIClient();

export function Rewards() {
  const { updateRewardsView, rewardsViewData } = useContext(RewardsViewContext);
  const [open, setOpen] = useState(false);
  const [myRewards, setMyRewards] = useState([]);
  const [countPendings, setCountPendings] = useState(0);
  const [isloading, setIsLoading] = useState(true);
  const [isUsedReward, setIsUsedReward] = useState(false);

  const handleGetMyRewards = async () => {
    try {
      setMyRewards([]);
      setCountPendings(0);
      let { data, status } = await api.get(`${url.GET_MY_REWARDS}${localStorage.getItem('doc')}`);
      if (status === 200 && 'data' in data) {
        let rewardsData = data?.data ?? [];
        if (Array.isArray(rewardsData) && rewardsData.length > 0) {
          setMyRewards(rewardsData);
          let pendings = rewardsData.filter(re => re?.used === false);
          setCountPendings(pendings.length);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1500);
    }
  }

  const handleClose = () => {
    updateRewardsView({ ...rewardsViewData, openDisclosure: false, openDisclosureMyRewards: false });
    setOpen(false);
  }

  const handleOpenDisclosure = () => {
    setOpen(true);
  }

  useEffect(() => {
    handleGetMyRewards();
  }, [isUsedReward]);

  useEffect(() => {
    const isOpen = !!rewardsViewData?.openDisclosureMyRewards; // Convierte a booleano
    if (isOpen) {
      handleOpenDisclosure();
    }
  }, [rewardsViewData?.openDisclosureMyRewards]);

  return (
    <>
      <div className={"w-full"} onClick={handleOpenDisclosure} href="#">
        <div className="cursor-pointer min-w-full">
          <div className="flex justify-between text-white">
            <span className="absolute" />
            <span className="sr-only">Mis recompensas</span>
            <PrimaryMobile text="Recompensas" />
          </div>
        </div>
      </div>

      <Dialog open={open} onClose={handleClose} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 transition-opacity duration-200 ease-in-out data-[closed]:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform transition duration-300 ease-in-out data-[closed]:translate-x-full"
              >
                <div className="flex h-full flex-col bg-darkBg tracking-tight font-walsheim">
                  <div className="">
                    <div className="py-6 bg-darkBg">
                      <div className="flex justify-between px-4 pt-8 ">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={handleClose}
                            className="relative text-white focus:outline-none"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                        <DialogTitle>
                          <div className="text-white">Mis recompensas</div>
                        </DialogTitle>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            onClick={handleClose}
                            className="relative text-white focus:outline-none"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {
                    isloading ? (
                      <>
                        <div className="p-3 text-grayP" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <div >
                            <div className="loader-clousure-movements"> </div>
                          </div>
                          Cargando...
                        </div>
                      </>
                    )
                      :
                      (

                        <>
                          <div className="h-full rounded-t-3xl bg-purpleLight p-4 overflow-y-auto">
                            <div className="flex justify-between text-grayP py-4">
                              <div className="">Pendientes de reclamar</div>
                              <div>({countPendings})</div>
                            </div>

                            {
                              countPendings > 0 && myRewards.length > 0 ? (
                                <RewardStory
                                  myRewards={myRewards}
                                  setIsUsedReward={setIsUsedReward}
                                  isUsedReward={isUsedReward}
                                />
                              ) :
                                (
                                  <>
                                    <div
                                      className="relative flex rounded-t-3xl tracking-tight font-walsheim"
                                    >
                                      <img
                                        className="py-4"
                                        style={{ margin: 'auto' }}
                                        width={200}
                                        height={200}
                                        src={img_empty_rewards}></img>
                                    </div>
                                    <div className="flex justify-center text-grayP py-4">
                                      <span>No tienes ninguna recompensa activa</span>
                                    </div>
                                  </>
                                )
                            }
                          </div>
                        </>
                      )
                  }

                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
